// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk } from 'types';

export const LOAD_EMPLOYEES = 'LOAD_EMPLOYEES';
export const loadEmployees = (): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_EMPLOYEES,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'get',
      url: 'api/user',
    },
  });
};

export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const createEmployee = (
  displayName,
  email,
  password
): ZuzuTunk => async dispatch => {
  return dispatchAsync({
    type: CREATE_EMPLOYEE,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'post',
      url: 'api/user',
      data: { displayName, email, password },
    },
  });
};

export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const deleteEmployee = (uid): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: DELETE_EMPLOYEE,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'delete',
      url: 'api/user',
      data: { uid },
    },
  });
};



// WEBPACK FOOTER //
// ./src/redux/actions/employees.js